// details-disclosure.js (hardened)
/* Wrap to avoid leaking globals */
(() => {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();

      // Find the <details> inside this custom element
      this.mainDetailsToggle = this.querySelector('details');

      // If markup isn't present, bail safely
      if (!this.mainDetailsToggle) {
        this.content = null;
        return;
      }

      // Resolve <summary> and the content element after it
      const summaryEl = this.mainDetailsToggle.querySelector('summary');
      this.content = summaryEl ? summaryEl.nextElementSibling : null;

      // Bind handlers once
      this.onFocusOut = this.onFocusOut.bind(this);
      this.onToggle = this.onToggle.bind(this);

      // Wire listeners
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut);
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle);
    }

    onFocusOut() {
      if (!this.mainDetailsToggle) return;
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onToggle() {
      if (!this.mainDetailsToggle || !this.content) return;

      // Guard for browsers without the Web Animations API
      if (typeof this.content.getAnimations === 'function') {
        if (!this.animations) this.animations = this.content.getAnimations();
        const isOpen = this.mainDetailsToggle.hasAttribute('open');
        this.animations.forEach((a) => {
          if (isOpen) a.play?.();
          else a.cancel?.();
        });
      }
    }

    close() {
      if (!this.mainDetailsToggle) return;
      this.mainDetailsToggle.removeAttribute('open');
      const summaryEl = this.mainDetailsToggle.querySelector('summary');
      if (summaryEl) summaryEl.setAttribute('aria-expanded', 'false');
    }
  }

  class HeaderMenu extends DetailsDisclosure {
    constructor() {
      super();
      this.header = document.querySelector('.header-wrapper');
    }

    onToggle() {
      if (!this.header || !this.mainDetailsToggle) return;
      this.header.preventHide = this.mainDetailsToggle.open;

      const varName = '--header-bottom-position-desktop';
      const current = document.documentElement.style.getPropertyValue(varName);
      if (current !== '') return;

      const bottom = Math.floor(this.header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty(varName, `${bottom}px`);
    }
  }

  // Avoid "NotSupportedError: this name has already been used" if included twice
  if (!customElements.get('details-disclosure')) {
    customElements.define('details-disclosure', DetailsDisclosure);
  }
  if (!customElements.get('header-menu')) {
    customElements.define('header-menu', HeaderMenu);
  }
})();
